<!--
일괄기능-출고작업
------------------------------------

-->
<template>
<div class="">
    
    <div class="uk-text-center uk-text-large3 uk-text-primary uk-margin-bottom">
        출고대상을 트럭에 실어보낸 후 [출고완료]를 클릭하세요
    </div>

    <!-- 버튼영역 -->
    <div class="uk-text-center">        
        <button 
            class="uk-button uk-button-primary  uk-button-large2"
            type="button"
            :disabled="disabled"
            v-on:click="$refs.done.jobInit()"
        >
            <i class="material-icons uk-text-middle" style="font-size: 40px">local_shipping</i>
            <span class="uk-text-middle">SHIP-OUT (출고완료)</span>
        </button>
    </div>
    
    <!-- DONE 기능 -->
    <app-batch-job-shipout-done
        ref="done"
        :batch="batch"
        :csrfToken="csrfToken"
        :region-id="regionId"
    ></app-batch-job-shipout-done>   
    
</div>
    
</template>

<script>
    export default {
        props: {
            /**
             * 일괄기능 공유data (상세정의는 컨트롤러 참고)
             */
            batch: Object,

            // csrf-token
            csrfToken: String,
            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },
        },
        data: function () {
            
            return {
            };
        },
        computed: {
            // 작업 버튼 비활성화 여부
            disabled() {
                // 선택된 아이템없으면 비활성화
                return this.batch.checked_item_count === 0;
            },

        },
        methods: {
        },
    }
</script>

<style lang="scss" scoped>
</style>